module.exports = __webpack_public_path__ + "static/media/chatIcon.f879ca19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MessageBar/chatIcon.svg
// module id = 1813
// module chunks = 0